import { css, keyframes } from "styled-components";

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;
export const grow = keyframes`
    from {
        scale: 0;
        opacity: 0;
    }
    to {
        scale: 1;
        opacity: 1;
    }
`;
export const shrink = keyframes`
    from {
        scale: 1;
        opacity: 1;
    }

    to {
        scale: 0;
        opacity: 0;
    }
`;
export const pulseAnimation = keyframes`
    0% {
        background-color: var(--disabled);
    }
    100% {
        background-color: var(--disabled-outline);
    }
`;
export const skeletonAnimation = css`
    animation: ${pulseAnimation} 1.5s linear infinite alternate;
`;
